/**
 * 종목 데이터 처리 유틸리티
 */
import { calculatePriceChange } from './trading/priceChange';
/**
 * API 응답 데이터를 StockWithPrice 배열로 변환
 * @param details - API 응답 종목 상세 배열
 * @param currentPrices - 종목별 현재가 맵
 * @returns StockWithPrice 배열
 */
export function transformStockData(details, currentPrices) {
    return details.map((detail) => {
        const currentPriceStr = currentPrices[detail.stockCd] || '0';
        const currentPrice = parseFloat(currentPriceStr);
        const { changeAmount, changeRate, direction } = calculatePriceChange(currentPrice, detail.closePrice);
        return {
            ...detail,
            currentPrice,
            changeAmount,
            changeRate,
            direction,
        };
    });
}
/**
 * 종목 데이터 필터링
 * @param stocks - 종목 배열
 * @param searchQuery - 검색어
 * @returns 필터링된 종목 배열
 */
export function filterStocks(stocks, searchQuery) {
    if (!searchQuery || searchQuery.trim() === '') {
        return stocks;
    }
    const query = searchQuery.toLowerCase();
    return stocks.filter((stock) => stock.stockCd.toLowerCase().includes(query));
}
/**
 * 종목 데이터 정렬
 * @param stocks - 종목 배열
 * @param sortBy - 정렬 기준
 * @param sortOrder - 정렬 순서
 * @returns 정렬된 종목 배열
 */
export function sortStocks(stocks, sortBy = 'stockCd', sortOrder = 'asc') {
    const sorted = [...stocks].sort((a, b) => {
        let compareValue = 0;
        switch (sortBy) {
            case 'stockCd':
                compareValue = a.stockCd.localeCompare(b.stockCd);
                break;
            case 'changeRate':
                compareValue = a.changeRate - b.changeRate;
                break;
            case 'currentPrice':
                compareValue = a.currentPrice - b.currentPrice;
                break;
        }
        return sortOrder === 'asc' ? compareValue : -compareValue;
    });
    return sorted;
}
/**
 * 종목 그룹별로 데이터 분류
 * @param stocks - 종목 배열
 * @returns 종목 그룹별 맵
 */
export function groupStocksByCategory(stocks) {
    const grouped = {
        ALL: stocks,
        FOREIGN: [],
        INDEX: [],
        COMMODITY: [],
        CRYPTO: [],
    };
    stocks.forEach((stock) => {
        const category = getStockCategoryByCode(stock.stockGroupCd);
        if (grouped[category]) {
            grouped[category].push(stock);
        }
    });
    return grouped;
}
/**
 * 종목 그룹 코드로 카테고리 결정
 */
function getStockCategoryByCode(stockGroupCd) {
    const map = {
        '01': 'FOREIGN',
        '02': 'INDEX',
        '03': 'COMMODITY',
        '04': 'CRYPTO',
    };
    return map[stockGroupCd] || 'ALL';
}
//# sourceMappingURL=stock.js.map